import React from 'react';
import { find } from 'lodash';
import $ from 'jquery';
import { withRouter } from 'react-router-dom';
import { Translate, useTranslate } from 'core/translate';
import { SvgIcon } from 'core/icons';
import {
  ButtonIcon,
  ButtonText,
  PrimaryButton,
  ThemedButton
} from 'core/controls';
import { combineClassNames } from 'core/css';

class StepNav extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      isExpanded: false,
      isExpanding: false,
      isCollapsing: false,
      isCollapsed: true,
      height: 0
    };
  }

  getTranslateHeight = () => {
    const ref = $(this.ref.current);
    return window.innerHeight * -1 + ref.height();
  };

  setTranslateHeight = () => {
    const height = this.getTranslateHeight();
    this.setState({ height: height });
  };

  expand = () => {
    if (this.state.isCollapsed) {
      const ref = $(this.ref.current);
      const container = $('#byo-web-ui');

      this.setState(
        {
          isCollapsed: false,
          isExpanding: true,
          height: this.getTranslateHeight()
        },
        () => {
          ref.one('transitionend', () => {
            container.css({ overflow: 'hidden' });
            $(window).on('resize', this.setTranslateHeight);
            this.setState({
              isExpanding: false,
              isExpanded: true
            });
          });
        }
      );
    }
  };

  collapse = () => {
    if (this.state.isExpanded) {
      const container = $('#byo-web-ui');
      const ref = $(this.ref.current);

      this.setState(
        {
          isExpanded: false,
          isCollapsing: true,
          height: 0
        },
        () => {
          container.css({ overflow: 'visible' });
          $(window).off('resize', this.setTranslateHeight);
          ref.one('transitionend', () => {
            this.setState({
              isCollapsing: false,
              isCollapsed: true
            });
          });
        }
      );
    }
  };

  handleTitleClick = () => {
    if (this.state.isExpanded) {
      this.collapse();
    } else {
      this.expand();
    }
  };

  handleLinkClick = step => {
    const { steps, history } = this.props;
    const active = steps.active;
    if (active) {
      this.collapse();
      if (!step.active) {
        history.push(step.path);
      }
    }
  };

  handlePrev = () => {
    const { history, steps } = this.props;
    const prev = steps.prev;
    if (prev) {
      this.collapse();
      history.push(prev.path);
    } else {
      this.handleTitleClick();
    }
  };

  handleNext = () => {
    const { history, steps } = this.props;
    const next = steps.next;
    if (next) {
      this.collapse();
      history.push(next.path);
    } else {
      this.handleTitleClick();
    }
  };

  getTransitionClassName = () => {
    const { isCollapsing, isExpanded, isExpanding } = this.state;
    if (isCollapsing) {
      return 'step-nav--collapsing';
    } else if (isExpanded) {
      return 'step-nav--expanded';
    } else if (isExpanding) {
      return 'step-nav--expanding';
    } else {
      return '';
    }
  };

  render() {
    const { steps } = this.props;
    const { prev, next, active } = steps;
    const summaryStep = find(steps.items, { key: 'SUMMARY' });
    if (!active) {
      return null;
    }

    const { height, isExpanding, isExpanded } = this.state;
    const transitionClassName = this.getTransitionClassName();
    const style =
      isExpanding || isExpanded
        ? { transform: 'translate3d(0, ' + height + 'px, 0)' }
        : {};
    return (
      <div
        className={combineClassNames(
          'step-nav',
          transitionClassName,
          'hide-for-large'
        )}
        style={style}
        ref={this.ref}>
        <div className="step-nav__container">
          <div
            className={combineClassNames(
              'step-nav-pager',
              !prev && 'step-nav-pager--hide-prev',
              !next && 'step-nav-pager--hide-next'
            )}>
            <div
              className="step-nav-pager__button step-nav-pager__prev stat-arrow-prev"
              onClick={this.handlePrev}
              data-dtm={prev ? 'nav' : active.key}>
              {prev && (
                <div className="text-center">
                  <div className="step-nav-pager__arrow">
                    <SvgIcon name="chevron-left" aria-hidden="true" />
                  </div>
                  <div className="step-nav-pager__label">
                    <Translate value="component.stepnav.prev" />
                  </div>
                </div>
              )}
            </div>

            <div
              className="step-nav-pager__title-actions stat-text-link"
              onClick={this.handleTitleClick}
              data-dtm={active.key}>
              <div>
                <div className="step-nav-pager__title">
                  <Translate value={active.key} />
                </div>
                <div className="step-nav-pager__label step-nav-pager__label--link">
                  <Translate
                    value="component.stepnav.status"
                    context={{
                      currentStep: active.index,
                      totalSteps: steps.items.length
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              className="step-nav-pager__button step-nav-pager__next stat-arrow-prev"
              onClick={this.handleNext}
              data-dtm={next ? 'nav' : active.key}>
              {next && (
                <div className="text-center">
                  <div className="step-nav-pager__arrow">
                    <SvgIcon name="chevron-right" aria-hidden="true" />
                  </div>
                  <div className="step-nav-pager__label">
                    <Translate value="component.stepnav.next" />
                  </div>
                </div>
              )}
            </div>
          </div>

          <Steps steps={steps} handleLinkClick={this.handleLinkClick} />

          <StepNavButtons
            handleLinkClick={this.handleLinkClick}
            active={active}
            summaryStep={summaryStep}
          />
        </div>
      </div>
    );
  }
}

const StepNavButtons = props => {
  const { handleLinkClick, active, summaryStep } = props;
  return (
    <div className="step-nav-states__button-container">
      <div className="step-nav-states__button-container-inner">
        <div className="step-nav-states__summary-button-container">
          <ThemedButton
            analytics="button"
            className="step-nav-states__button step-nav-states__summary-button"
            theme={{
              fallback: 'button--secondary',
              cadillac: 'button--link button--inline-flex',
              gmc: 'button--link'
            }}
            onClick={() => handleLinkClick(summaryStep)}>
            <ButtonText>
              <Translate value="component.stepnav.summary" />
            </ButtonText>
            <ButtonIcon name="chevron-right" />
          </ThemedButton>
        </div>
        <div className="step-nav-states__continue-button-container">
          <PrimaryButton
            analytics="button"
            className="step-nav-states__button step-nav-states__continue-button"
            onClick={() => handleLinkClick(active)}>
            <ButtonText>
              <Translate value="component.stepnav.continue" />
            </ButtonText>
          </PrimaryButton>
        </div>
      </div>
    </div>
  );
};

const Steps = props => {
  const { steps, handleLinkClick } = props;
  const translate = useTranslate();
  return (
    <div className="step-nav-states__list">
      {steps.items.map(step => {
        return (
          <div
            className={combineClassNames(
              'step-nav-states__state stat-text-link',
              step.active && 'step-nav-states__state--active'
            )}
            data-dtm={translate(step.key)}
            onClick={() => handleLinkClick(step)}
            key={step.key}>
            <Translate value={step.key} />

            {step.active && (
              <SvgIcon name="pencil" className="step-nav-states__active-icon" />
            )}

            {step.visited &&
              !step.active && (
                <SvgIcon
                  name="step-nav-check"
                  className="step-nav-states__visited-icon"
                />
              )}
          </div>
        );
      })}
    </div>
  );
};

export default withRouter(StepNav);
